<template>
	<FcknRow v-bind="fcknRowData" @open-preorder="openPreOrderDrawer" />

	<Scroller id="global" ref="mainScroller" :main="true">
		<NuxtPage />
	</Scroller>

	<Navbar v-bind="dataNavbar" />
	<PreOrderDrawer
		v-model="isPreOrderDrawerOpen"
		:description="preOrderDescription"
		privacy-url="https://burocratik.com/privacy-policy"
	/>

	<Loading :title="`${SITE_NAME} — ${SITE_DESCRIPTION}`" />
	<Grid />
</template>

<script setup>
import { SITE_NAME, SITE_DESCRIPTION } from './config/site'
import { Grid, Scroller, getActiveContext } from '@/components/core'

import { Loading, Navbar } from '@/components/navigation'
import { FcknRow } from '@/components/fragments/FcknRow'
import { PreOrderDrawer } from '@/components/fragments/PreOrderDrawer'
import dataNavbar from '@/components/navigation/Navbar/data'
import landingContent from '@/components/pages/Landing/content'

import { useScreen } from 'vue-screen'
import { breakpoints } from './config'

const mainScroller = ref(null)
const fcknRowData = {
	year: landingContent.header.year,
	yearLabel: landingContent.header.yearLabel,
}
const preOrderDescription =
	landingContent.sections.find((section) => section.id === 'title-with-tag-4')?.props?.title ?? ''
const isPreOrderDrawerOpen = ref(false)

const screen = useScreen()
const isMobile = ref(null)

function openPreOrderDrawer() {
	isPreOrderDrawerOpen.value = true
}

onMounted(() => {
	nextTick(() => {
		isMobile.value = screen.width < breakpoints.small
	})
})

watch(
	() => screen?.width,
	(width) => {
		isMobile.value = width < breakpoints.small
	},
)

provide('$scroller', mainScroller)
provide('$page', {
	get pageCtx() {
		return { $page: getActiveContext() }
	},
})
</script>

<style lang="scss" scoped>
[data-component='pre-loader'] {
	--preload-color: var(--color-geral-white);
}
</style>
